import { creaFiltroDeAvisosRepetidos } from '@/common/helpers/filtroAvisosRepetidos'
import { notifications } from '@/common/helpers/notifications'

/**
 * Avisa de que no se pudo renovar la sesión, sin llenar la pantalla de mensajes.
 *
 * El caso que hay que respetar es el de quedarse sin red hacia Microsoft: `authHeader` corre en
 * **cada llamada a la API**, así que una pantalla que carga seis grids dispararía seis avisos
 * idénticos, y una que reintenta, decenas. Por eso el aviso pasa por el mismo filtro de repetidos
 * que usa el visor de reportes: se dice una vez y se calla mientras el problema siga igual.
 *
 * Antes esto era un `console.warn` en `useAuthHeader` y nada en `authHeader`. El usuario veía
 * pantallas vacías o a medio cargar sin ninguna explicación: exactamente el mismo hueco que ya se
 * cerró en el dashboard del Home y en el visor.
 *
 * No cubre la sesión caducada de verdad: eso lo resuelve `redirectToLoginPreservingRoute`, que
 * lleva al login en vez de avisar. Esto es para el fallo **transitorio**, donde reintentar sirve.
 */
const filtrar = creaFiltroDeAvisosRepetidos()

export const avisarProblemaDeSesion = (error: unknown): void => {
  const mensaje = 'No se pudo renovar la sesión. Revise su conexión; algunos datos pueden no cargarse.'

  if (!filtrar(mensaje, Date.now())) {
    return
  }

  notifications({
    title: 'Problema con la sesión',
    message: mensaje,
    ex: error,
    toastType: 'warning',
  })
}
